// @ts-nocheck

import memoize from 'memoize-state';

import { BetslipTypes } from '../../../types/history';
import roundBoosterPercent from '../../../utils/roundBoosterPercent';

import { getBetslipFromProps } from './common';

export const bonusSelector = memoize((state, props) => {
  const betslip = getBetslipFromProps(state, props);
  const {
    winningsAmount,
    winningsBonus,
    possibleWinnings,
    possibleBonus,
    betAmount,
    promotionTitle,
    promotionCodeId,
    type,
  } = betslip;

  const bonusAmount = possibleBonus || winningsBonus || 0;

  let winnings = 0;
  if (winningsAmount !== null && winningsAmount !== undefined) {
    winnings = winningsAmount;
  } else if (possibleWinnings) {
    winnings = possibleWinnings;
  }

  const isSystem = type === BetslipTypes.SYSTEM;
  const isCombobooster = promotionCodeId && promotionCodeId.indexOf('BOOSTER-PERMANENT') !== -1;
  const boosterPercent =
    isCombobooster && !isSystem && winnings ? roundBoosterPercent((bonusAmount / (winnings - betAmount)) * 100) : null;

  const trimQuotes = promotionTitle.match(/^"(.+)"$/, '');
  const finalPromotionTitle = (trimQuotes && trimQuotes[1]) || promotionTitle;

  return {
    bonus: bonusAmount,
    boosterPercent,
    promotionTitle: finalPromotionTitle,
    isSystem,
  };
});
